module.exports = __webpack_public_path__ + "a2eeddf313b9b06631d74f2ca9458ae7.png";